import { GlobalWorkerOptions, PDFWorker, version as pdfjsVersion } from 'pdfjs-dist';

GlobalWorkerOptions.workerSrc = `/pdfworker/${pdfjsVersion}/worker/pdf.worker.min.js`;
export const pdfWorker = new PDFWorker();
